var splash = ( function ( $ ) {

	var $splash;

	var _init = function () {
		$splash = $( '#splash' );

		_remove_splash();
	};

	var _remove_splash = function() {
		setTimeout( function() {
			$( '#splash-content' ).fadeOut( 1000 );
		}, 1800 );

		setTimeout( function() {
			$( '#splash' ).fadeOut( 1000 );
		}, 2600 );

		_set_splash_cookie();
	};

	var _set_splash_cookie = function() {
		$.cookie( 'splash_seen' , 'true' );
	};

	if ( $( '#splash' ).length > 0 ) {
		$( document ).ready( _init );
	}

})( jQuery );

module.exports = splash;
